import { render } from "./ProjectOffers.vue?vue&type=template&id=0b2b2a56"
import script from "./ProjectOffers.vue?vue&type=script&lang=js"
export * from "./ProjectOffers.vue?vue&type=script&lang=js"

import "./ProjectOffers.vue?vue&type=style&index=0&id=0b2b2a56&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__